// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: "df6cea93-8c1c-456c-99dc-9277da70ba23", // This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/common", // "common" allows both Work/School accounts and Personal Microsoft accounts
        redirectUri: window.location.origin, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["User.Read", "Mail.Send", "Mail.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
